import { useState, useEffect, useMemo } from 'react';
import { useApolloClient } from '@apollo/client';

export default function useAwaitQueries(awaitQueries) {
  const apolloClient = useApolloClient();
  const [readyAwaitQueries, setReadyAwaitQueries] = useState({});

  useEffect(function() {
    const subscriptions = awaitQueries.map((options, index) => (
      apolloClient.watchQuery(options).subscribe({
        next: value => setReadyAwaitQueries(object => {
          return { ...object, [index]: value };
        }),
        error: error => console.error(error),
      })
    ));

    return function() {
      subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }, [awaitQueries, apolloClient]);

  const readyAwaitQueriesArray = useMemo(() => (
    Object.values(readyAwaitQueries)
  ), [readyAwaitQueries]);

  const awaitQueryReady = readyAwaitQueriesArray.length === awaitQueries.length;

  return [readyAwaitQueriesArray, awaitQueryReady];
}
